$(document).ready(function(){
   // debugger;
//console.log("HEY");
  $('.customer-list').slick({
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1
     });

});



// // $(function() {
//   $('.customer-list').slick({
//   infinite: true,
//   slidesToShow: 3,
//   slidesToScroll: 3
// })

//   })